export default __webpack_public_path__ + "static/media/Sketchers.0782bd06.png";